'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _lodash = require('lodash');

var _AcceptedCardTypes = require('./AcceptedCardTypes.scss');

var _AcceptedCardTypes2 = _interopRequireDefault(_AcceptedCardTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AcceptedCardTypes = (_dec = (0, _reactCssModules2.default)(_AcceptedCardTypes2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(AcceptedCardTypes, _React$Component);

  function AcceptedCardTypes() {
    (0, _classCallCheck3.default)(this, AcceptedCardTypes);
    return (0, _possibleConstructorReturn3.default)(this, (AcceptedCardTypes.__proto__ || (0, _getPrototypeOf2.default)(AcceptedCardTypes)).apply(this, arguments));
  }

  (0, _createClass3.default)(AcceptedCardTypes, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'm-accepted-card-types' },
        this.props.cardTypes.map(function (cardType) {
          return _react2.default.createElement('img', { key: (0, _lodash.uniqueId)(), srcSet: require('./assets/' + cardType + '.png'), alt: cardType });
        })
      );
    }
  }]);
  return AcceptedCardTypes;
}(_react2.default.Component), _class2.propTypes = {
  cardTypes: _react.PropTypes.array
}, _temp)) || _class);
exports.default = AcceptedCardTypes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/PaymentOption/AcceptedCardTypes.js
// module id = 2484
// module chunks = 0